export default __webpack_public_path__ + "static/media/download-app-img-b.d48160a1.webp";